<div class="block-header">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <ng-content></ng-content>
    </div>
  </div>
</div>
